export const DISocketTypes = {
  SocketConnection: Symbol('SocketConnection'),
  SocketClient: Symbol('SocketClient'),
  SocketClientFactory: Symbol('SocketClientFactory'),
  SocketDispatcher: Symbol('SocketDispatcher'),
  SocketDispatcherFactory: Symbol('SocketDispatcherFactory'),
};
